import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/nakshatraLogo.png";
import {BsFacebook} from 'react-icons/bs'
import {AiFillInstagram} from 'react-icons/ai'

import "./Navbar.css";

// const logo = new URL("../assets/nakshatraLogo.png, import.meta.url");

const Nav = () => {
const [navOpen, setNavOpen] = useState(false);

  return (

    <div className="nav">
      <div className="nav-container">
        <div className="navbar">
          <div className="logo" style={{fontFamily:'Orbitron', fontSize:'0.1rem'}}>
            {/* NAKSHATRA */}
            {/* <img src= {logo} /> */}
            <img style={{paddingLeft: '30px', width: '150px'}} src={logo} className="mainlogo" alt="/"  />
            </div>
          <div className="menu-toggle" onClick={() => setNavOpen(!navOpen)}>
            <div className={navOpen ? "hamBox hamBoxOpen" : "hamBox"}>
              <span className={navOpen ? "lineTop spin" : "lineTop"}></span>
              <span
                className={navOpen ? "lineBottom spin" : "lineBottom"}
              ></span>
            </div>
          </div>
        </div>

        <div
          className="nav-overlay"
          style={{
            top: navOpen ? "0" : "-100%",
            transitionDelay: navOpen ? "0s" : "0s",
          }}
        >
          <ul className="nav-links">
            <li className="nav-item">
              <Link
                to="/"
                onClick={() => setNavOpen(!navOpen)}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "1s" : "0s",
                  textAlign: "center",
                }}
                data-text="Home"
              >
                Home
              </Link>
              <div className="nav-item-wrapper"></div>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                onClick={() => setNavOpen(!navOpen)}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "1.6s" : "0s",
                  textAlign: "center",
                }}
                data-text="About"
              >
                About
              </Link>
              <div className="nav-item-wrapper"></div>
            </li>
            <li className="nav-item">
              <Link
                to="/sponsors"
                onClick={() => setNavOpen(!navOpen)}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "1.8s" : "0s",
                  textAlign: "center",
                }}
                data-text="Sponsors"
              >
                Sponsors
              </Link>
              <div className="nav-item-wrapper"></div>
            </li>
           
            <li className="nav-item">
              <Link
                to="/gallery"
                onClick={() => setNavOpen(!navOpen)}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "2s" : "0s",
                }}
                data-text="Gallery"
              >
                Gallery
              </Link>
              <div className="nav-item-wrapper"></div>
            </li>

            {/* <li className="nav-item">
              <Link
                to="/contact"
                onClick={() => setNavOpen(!navOpen)}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "2s" : "0s",
                }}
              >
                Gallery
              </Link>
              <div className="nav-item-wrapper"></div>
            </li> */}
            
          </ul>
          
          
          
          
          
          
          <div className="nav-footer">
            <div
              className="location"
              style={{
                bottom: navOpen ? "0" : "-20px",
                opacity: navOpen ? "1" : "0",
                transitionDelay: navOpen ? "1.2s" : "0s",
              }}
            >
              <span>NSUT, Delhi</span>
            </div>
            <div className="nav-social-media">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/Nakshatra.DU"
                    target="_blank"
                    style={{
                      bottom: navOpen ? "0" : "-20px",
                      opacity: navOpen ? "1" : "0",
                      transitionDelay: navOpen ? "1.3s" : "0s",
                    }}
                  >
                    <BsFacebook style={{fontSize:'22px'}} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/nakshatra_nsut/"
                    target="_blank"
                    style={{
                      bottom: navOpen ? "0" : "-20px",
                      opacity: navOpen ? "1" : "0",
                      transitionDelay: navOpen ? "1.4s" : "0s",
                    }}
                  >
                    <AiFillInstagram style={{fontSize:'25px'}} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;